<template>
  <v-btn text @click="deleteClickAction">
    <v-icon color="#74B8BE">mdi-close-circle</v-icon>
  </v-btn>
</template>

<script>

export default {
  name: "CheckListItemDeleteButton",
  data: () => ({
  }),
  methods: {
    deleteClickAction() {
      this.$emit('deleteClickAction')
    }
  },
  created() {
  },
  components: {
  },
  props: []
};

</script>

<style scoped>
</style>
